"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkboxGroupConfig = exports.CheckboxGroupDefinition = void 0;

var _types = require("../../types");

var _config = require("../config");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var FieldConfigDefinition = _flowRuntime["default"].tdz(function () {
  return _config.FieldConfigDefinition;
});

var OptionsElementDefinition = _flowRuntime["default"].tdz(function () {
  return _types.OptionsElementDefinition;
});

var CheckboxGroupDefinition = _flowRuntime["default"].type("CheckboxGroupDefinition", _flowRuntime["default"].spread(_flowRuntime["default"].ref(OptionsElementDefinition), _flowRuntime["default"].object(_flowRuntime["default"].property("type", _flowRuntime["default"].string("checkboxGroup")))));

exports.CheckboxGroupDefinition = CheckboxGroupDefinition;
var checkboxGroupConfig = {
  type: 'checkboxGroup'
};
exports.checkboxGroupConfig = checkboxGroupConfig;